/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import Constants from '../Constants'

const updateOptions = (options: object): object => {
  return {
    ...options,
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  }
}

const apiFetcher = (url: string, options: object = {}) => {
  return fetch(Constants.API_URL + url, updateOptions(options))
}

export default apiFetcher
